import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=5064d0cb&"
import script from "./SearchModal.vue?vue&type=script&lang=js&"
export * from "./SearchModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports